import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/ui/Button";
import { getWaypointById } from "../../../../api";
import TitleSubtitle from "../../../../components/common/TitleSubtitle";
import TextInput from "../../../../components/ui/TextInput";
import { WaypointCoordinatesProps, RouteParams } from "../../../../types/screensTypes";
import { useWaypointChangeDetection } from "../../../../hooks/useWaypointChangeDetection";
import stepStyles from "../createStep.module.css";
import wp from "./WaypointEdit.module.css";

const WaypointCoordinates: React.FC<WaypointCoordinatesProps> = ({ navigateToNext }) => {
    const { wptId, language } = useParams<RouteParams>();

    const {
        value: coordinates,
        setValue: setCoordinates,
        saveIfChanged,
        setOriginalValue,
    } = useWaypointChangeDetection<string>({
        wptId: wptId || "",
        language,
        initialValue: "",
    });
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const getWaypoint = async (id: string): Promise<void> => {
        const token = localStorage.getItem("token");
        if (!token || !language) return;
        const waypointData = await getWaypointById({ token, id, language });
        let loadedCoordinates = "";

        if (waypointData) {
            const waypointArray = waypointData;
            if (waypointArray && waypointArray.waypointTemporary) {
                const latitude = waypointArray.waypointTemporary.latitude;
                const longitude = waypointArray.waypointTemporary.longitude;
                if (latitude && longitude) {
                    loadedCoordinates = latitude + "," + longitude;
                }
            } else {
                const waypoint = waypointArray.waypoint;
                if (waypoint && waypoint.point) {
                    loadedCoordinates = waypoint.point.lat + "," + waypoint.point.lng;
                }
            }
        }

        setCoordinates(loadedCoordinates);
        setOriginalValue(loadedCoordinates);
    };

    const saveWaypoint = async (): Promise<void> => {
        if (coordinates.trim() !== "" && coordinates !== "") {
            const [latitude, longitude] = coordinates.split(",");
            if (latitude && longitude) {
                await saveIfChanged({
                    latitude: parseFloat(latitude.trim()),
                    longitude: parseFloat(longitude.trim()),
                });
            }
        }
        if (!wptId || !language) return;
        navigateToNext(wptId, language);
    };

    useEffect(() => {
        if (wptId && wptId !== "") {
            getWaypoint(wptId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wptId, language]);

    return (
        <div className={`${stepStyles.editScreen} ${wp.screen}`}>
            <TitleSubtitle title={t("modifyCoordinates")} subtitle={""} layout="edit" />
            <div className={wp.coordField}>
                <TextInput
                    placeholder={t("enterCoordinatesLatLng")}
                    value={coordinates}
                    size="small"
                    onChange={(e) => setCoordinates(e.target.value)}
                />
            </div>
            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                    label={t("continue")}
                    onClick={saveWaypoint}
                />
            </div>
        </div>
    );
};

export default WaypointCoordinates;
